<template>
    <div class="header">
        <div class="desktop-menu">
            <b-container>
                <a href="/" class="logo"><img src="@/assets/images/logo.svg" alt="логоитип" width="60px"></a>
                <template v-for="(route,index) in $router.options.routes.filter(el=>el.meta.showmenu && !el.meta.admin)">                    
                    <div v-if="route.children" :key="index" :href="route.path" class="links-list link-header">
                        {{getCaption(route)}}
                        <div v-if="route.children" class="links-list-drop">
                            <a v-for="(subroute,i) in route.children.filter(el=>el.meta.showmenu && !el.meta.admin)" :key="i" :href="route.path+'/'+subroute.path">{{getCaption(subroute)}}</a>
                        </div>                    
                    </div>
                    <a v-else :key="index" :href="route.path" class="links-list">
                        {{getCaption(route)}}                                        
                    </a>
                </template>
                
            </b-container>
        </div>
        <header-mobile :pages="pages" :routes="$router.options.routes.filter(el=> !el.meta.admin)"></header-mobile>      
    </div>    
</template>

<script>
import HeaderMobile from "@/components/components/HeaderMobile";
export default {
    props:['pages'],
    data(){
        return {
            test:{}
        }
    },
    methods: {
        getCaption(route){
            let alias = route.path.split("/")
            let pagecaption = this.pages.find(page => page.alias == alias[alias.length-1]) 
            return (pagecaption && pagecaption.caption) ? pagecaption.caption : route.name
        },  
    },
    components: {
        'header-mobile':HeaderMobile
    },
};
</script>

<style lang="scss">

.bg-top{
    width: 100vw;
    height: 50px;
    background-color: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
}
.bg{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left:0;
    z-index: 98;
    background-color: #000;
    opacity: 0.2;
  }  
  .desktop-menu{
      width: 100%;
      background-color: rgba($color: #000000, $alpha: 0.5);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      a,.link-header{
          display: inline-block;
          height: 70px;
          vertical-align: top;
          color:#fff;
          font-size: 18px;          
          text-align: center;
          line-height: 45px;     
          cursor: pointer;     
          &:hover{
              /*background-color: rgba($color: #000000, $alpha: 0.2);*/
              text-decoration: none;
              background-color: $hover-color;
          } 
          &.logo{
            height: 60px;
            margin: 5px;
            border-radius: 50%;
            /*background-color: rgb(187 187 187 / 38%);*/
            box-shadow: 2px 2px 20px 1px #000;
            &:hover{
              /*background-color: rgba($color: #000000, $alpha: 0.2);*/
              text-decoration: none;
              /*background-color: $hover-color;*/
              background-color:transparent;
              
          } 
          }
          &.links-list{
              width: calc((100% - 100px) / 5);
              padding-top:10px;
              padding-bottom: 10px;   
              position: relative;     
              .links-list-drop{
                  position: absolute;
                  display: none;
                  top:70px;                  
                  a{
                    line-height: 1.2;
                    background-color: #555;
                    width: 100%;
                    height: auto;
                    display: block;
                    padding: 10px 5px;
                    font-size: 14px;
                    border-top: 1px solid #ccc;
                      &:hover{
                          background-color: $hover-color;                          
                      }
                  }
              } 
              &:hover{
                  .links-list-drop{
                      display: block;
                  }
              }    
          }
      }      
  }
  .mobile-menu{
        display: none;
    }
    @media (max-width: 1024){
        .desktop-menu{
           background-color: rgba($color: #000000, $alpha: 0.1);
        }
        
    }
    @media (max-width:992px) {         
       .desktop-menu a{
           font-size: 18px;
       }
   }
   @media (max-width:767px) { 
       .mobile-menu{
           display: block;
       }
       .desktop-menu{
           display: none;
       }
   }
</style>